<template>
    <div class="line" :class="{bigger: bigger}">&nbsp;</div>
</template>

<script>
    export default {
        props: {
            bigger: {
                type: Boolean,
                default: false
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../styles/base';

    .line {
        height: 1px;
        width: 100%;
        background-color: $accent;
        /*margin: 0;*/

        &.bigger {
            height: 2px;
        }
    }
</style>